var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { Table } from 'components';
import { Input } from 'reactstrap';
import theme from '../../../Theme';
import { Button } from '../../../elements';
import './css/Collaborators.css';
import { loading } from '../../../elements/Loading';
import { T } from '../../../helpers/i18n';
var CollaboratorsTable = /** @class */ (function (_super) {
    __extends(CollaboratorsTable, _super);
    function CollaboratorsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/collaborators/".concat(value.id));
        };
        _this.handleCreate = function () {
            console.log('handleCreate');
            history.push("/collaborators/create");
        };
        _this.handleSelect = function (row, isSelect) {
            console.log('row: ', row);
            history.push("/collaborators/".concat(row.id));
        };
        return _this;
    }
    CollaboratorsTable.prototype.componentDidMount = function () {
        this.props.store.businessUnits.read();
    };
    CollaboratorsTable.prototype.render = function () {
        var collaborators = this.props.store.collaboratorStore.collaborators || [];
        console.log('collaboratos: ', collaborators);
        var headers = ['id', 'status', 'name', 'businessName', 'tradeName', 'codeCollaborator', 'tin'];
        return (React.createElement(Table, { items: collaborators, header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); } }));
    };
    CollaboratorsTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.collaboratorStore.read().then(function (collaborator) { return ({ collaborator: collaborator }); })
            ];
        }),
        observer
    ], CollaboratorsTable);
    return CollaboratorsTable;
}(Component));
export default CollaboratorsTable;
var columns = [
    {
        dataField: 'codeCollaborator',
        text: T('collaboratorCode'),
        tooltipDataField: 'tooltip',
        sort: true
    },
    {
        dataField: 'businessName',
        text: T('collaboratorName')
    },
    {
        dataField: 'email',
        text: T('collaboratorEmail')
    },
    {
        dataField: 'tin',
        text: T('collaboratorTin')
    },
    {
        dataField: 'status',
        text: T('status')
    }
];
/*const { ToggleList } = ColumnToggle;*/
var customTotal = function (from, to, size) { return (React.createElement("span", { className: " ml-4" }, "".concat(T('showing'), " ").concat(from, " ").concat(T('to'), " ").concat(to, " ").concat(T('of'), " ").concat(size, " ").concat(size > 1 ? T('results') : T('result')))); };
var sizePerPageRenderer = function (_a) {
    var options = _a.options, currSizePerPage = _a.currSizePerPage, onSizePerPageChange = _a.onSizePerPageChange;
    return (React.createElement("span", { className: "col-12" },
        React.createElement("label", { className: "d-inline mr-1" }, "Show"),
        React.createElement("label", { className: "d-inline ml-1" }, "entries"),
        React.createElement(Input, { type: "select", name: "select", id: "no-entries", className: "custom-select custom-select-sm d-inline col-sm-3 col-lg-2 col-md-2", defaultValue: currSizePerPage, onChange: function (e) { return onSizePerPageChange(e.target.value); }, style: { maxWidth: '50px' } }, options.map(function (option, idx) {
            return React.createElement("option", { key: idx }, option.text);
        }))));
};
var pageButtonRenderer = function (_a) {
    var page = _a.page, active = _a.active, disabled = _a.disabled, title = _a.title, onPageChange = _a.onPageChange;
    var handleClick = function () {
        onPageChange(page);
    };
    var activeStyle = {};
    if (active) {
        activeStyle.color = theme.color.primary;
    }
    else {
        activeStyle.color = theme.color.secondary;
    }
    if (typeof page === 'string') {
        activeStyle.color = 'black';
    }
    return (React.createElement("div", { className: "'btn-group btn-group-toggle" },
        React.createElement(Button, { className: "btn", primary: active, style: activeStyle, onClick: function () { return handleClick(); } }, page)));
};
var paginationOptions = {
    pageButtonRenderer: pageButtonRenderer,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageRenderer: sizePerPageRenderer,
    onPageChange: function (page, sizePerPage) {
        handleOnPageChange(page, sizePerPage);
    },
    onSizePerPageChange: function (sizePerPage, page) {
        handleOnSizePerPageChange(sizePerPage, page);
    },
    sizePerPageList: [
        {
            text: '5',
            value: 5
        },
        {
            text: '10',
            value: 10
        },
        {
            text: '25',
            value: 25
        }
        /*{
          text: 'All',
          value: collaborators.length,
        },*/
    ] // A numeric array is also available. the purpose of above example is custom the text
};
var defaultSorted = [
    {
        dataField: 'id',
        order: 'asc'
    }
];
var handleOnSizePerPageChange = function (sizePerPage, page) {
    console.log('onSizePerPageChange');
};
var handleOnPageChange = function (page, sizePerPage) {
    console.log('onPageChange, page: ', page);
    console.log('onPageChange, sizePerPage: ', sizePerPage);
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Collaborators/container/CollaboratorsTable.tsx
// module id = 1562
// module chunks = 0